import React, { ComponentType } from 'react';
import { Box, BoxProps } from '@wix/design-system';
import TemplateCardImage from '../TemplateCardImage';
import { TemplateGalleryCard } from '@common/types';
import s from '../TemplateCard.module.scss';

export interface LoadedTemplateCardProps {
  template: TemplateGalleryCard;
  index: number;
  hover: boolean;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  overlayContent?: React.ReactElement;
  minHeight?: BoxProps['minHeight'];
  mediaContainerClassName?: string;
  CardInfo: ComponentType<{ template: TemplateGalleryCard; hovered: boolean }>;
}

const TemplateLoadedCard = ({
  template,
  index,
  hover,
  setHover,
  overlayContent,
  minHeight = '322px',
  mediaContainerClassName,
  CardInfo,
}: LoadedTemplateCardProps) => {
  return (
    <Box
      className={s.template}
      direction="vertical"
      minWidth="232px"
      minHeight={minHeight}
      overflow="hidden"
      borderRadius="4px"
      verticalAlign="middle"
      dataHook="desktop-card"
    >
      <TemplateCardImage
        imageSource={template.media?.longThumbnail?.url}
        description={template.media?.longThumbnail?.description ?? ''}
        index={index}
        animatedPreview={template.media?.animatedPreview}
        hovered={hover}
        overlayContent={overlayContent}
        mediaContainerClassName={mediaContainerClassName}
      />
      <div onMouseEnter={() => setHover(true)}>
        <CardInfo template={template} hovered={hover} />
      </div>
    </Box>
  );
};

export default TemplateLoadedCard;
